import "./Input.scss";
import { MotifInput, MotifErrorMessage } from "../../../assets/lib/motif";

export function Input({
  label,
  onChange,
  value,
  id = crypto.randomUUID(),
  className,
  type,
  required = false,
  disabled = false,
  onBlur,
  onKeyDown,
  maxLength = 110,
  isError,
  errorMessage,
  disableErrorPlaceholder = true,
  hideClearButton = false,
  placeholder,
  onPaste,
  allowNegative = false,
  onMouseOut,
  ...other
}) {
  const numberRegExp = /^[0-9\b]+$/;
  const decimalNumberRegExp = /^\d{1,11}(\.\d{1,2})?$/;

  function onInputChange(event) {
    const value = event.target?.value;
    if (value?.includes("</") || value?.includes(">") || value?.includes("<")) {
      event.target.value = value.replace(/[<>/]/g, "");
      return;
    }
    if (event.target?.value) {
      if (maxLength && event.target?.value.length <= maxLength) {
        onChange(event);
      }
    }

    onChange(event);
  }

  const onInputKeyDown = (event) => {
    if (type === "number") {
      if (
        event.key === "e" ||
        event.key === "+" ||
        event.key === "E" ||
        event.key === "."
      ) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (!allowNegative && event.key === "-") {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    }

    if (type === "decimal") {
      const nonNumericKeys = /[^-0-9.]/;
      const controlKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Enter", "Escape"];
      if (!controlKeys.includes(event.key) && nonNumericKeys.test(event.key)) {
      event.preventDefault();
      event.stopPropagation();
      return;
      }
    }

    onKeyDown && onKeyDown(event);
  };

  const onInputPaste = (event) => {
  const pastedData = event.clipboardData.getData("text");

  // Validate based on type
  if (type === "number" && !numberRegExp.test(pastedData)) {
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  if (type === "decimal" && !decimalNumberRegExp.test(pastedData)) {
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  // Enforce maxLength strictly
  const currentValue = event.target.value || "";
  const selectionStart = event.target.selectionStart || 0;
  const selectionEnd = event.target.selectionEnd || 0;
  const newLength = currentValue.length - (selectionEnd - selectionStart) + pastedData.length;

  if (maxLength && newLength > maxLength) {
    event.preventDefault();
    return;
  }

  onPaste && onPaste(event);
};

  return (
    <div style={{ flex: 1 }}>
      <MotifInput
        {...other}
        id={id}
        label={label}
        onChange={onInputChange}
        value={value}
        className={`decarb-input ${className}`}
        type={type}
        required={required}
        disabled={disabled}
        onBlur={onBlur}
        onKeyDown={onInputKeyDown}
        maxLength={maxLength}
        hideClearButton={hideClearButton || disabled}
        placeholder={placeholder}
        onPaste={onInputPaste}
        autoComplete={"off"}
        onMouseOut={onMouseOut}
      />
      {isError ? (
        <MotifErrorMessage className="decarb-input-error-message">
          {errorMessage}
        </MotifErrorMessage>
      ) : !disableErrorPlaceholder ? (
        <div className="decarb-input-hide-error">No Error</div>
      ) : (
        <></>
      )}
    </div>
  );
}
